import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Container, Row, Col, Badge } from 'react-bootstrap';
import BeforeAfterCarousel from '../components/BeforeAfterCarousel';
import MasonryGallery from '../components/MasonryGallery';
import data from '../data/stdominicana-original';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../scss/pages/_completed-projects.scss';

const CompletedProjects = () => {
  const { completedProjects } = data;
  const [selectedCategory, setSelectedCategory] = useState('Todos');

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out-cubic',
      offset: 100,
      disable: false,
      anchorPlacement: 'top-bottom',
    });
  }, []);

  // Refresh AOS when category changes to re-animate filtered items
  useEffect(() => {
    AOS.refresh();
  }, [selectedCategory]);

  // Get unique categories
  const categories = ['Todos', ...new Set(completedProjects.projects.map(p => p.category))];

  // Filter projects by category
  const filteredProjects = selectedCategory === 'Todos'
    ? completedProjects.projects
    : completedProjects.projects.filter(p => p.category === selectedCategory);

  return (
    <>
      <Helmet>
        <title>{completedProjects.title} - Soluciones Térmicas Dominicana</title>
        <meta name="description" content={completedProjects.description} />
      </Helmet>

      <div className="completed-projects-page">
        {/* Hero Section */}
        <section className="projects-hero">
          <Container>
            <Row className="justify-content-center text-center">
              <Col lg={10}>
                <h1
                  className="page-title"
                  data-aos="fade-down"
                  data-aos-delay="100"
                >
                  {completedProjects.title}
                </h1>
                <p
                  className="page-subtitle"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  {completedProjects.subtitle}
                </p>
                <p
                  className="page-description"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  {completedProjects.description}
                </p>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Category Filter */}
        <section className="category-filter">
          <Container>
            <Row className="justify-content-center">
              <Col lg={10}>
                <div className="filter-buttons" data-aos="fade-up" data-aos-delay="100">
                  {categories.map((category, index) => (
                    <button
                      key={category}
                      className={`filter-btn ${selectedCategory === category ? 'active' : ''}`}
                      onClick={() => setSelectedCategory(category)}
                      data-aos="zoom-in"
                      data-aos-delay={150 + (index * 50)}
                    >
                      {category}
                    </button>
                  ))}
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Projects Gallery */}
        <section className="projects-gallery">
          <Container>
            <Row className="g-4">
              {filteredProjects.map((project, index) => (
                <Col key={project.id} xs={12}>
                  <div
                    className="project-card"
                    data-aos="fade-up"
                    data-aos-delay={index * 150}
                  >
                    <div className="project-header">
                      <div className="project-meta">
                        <Badge bg="secondary" className="category-badge">
                          {project.category}
                        </Badge>
                      </div>
                      <h3 className="project-title">{project.title}</h3>
                    </div>

                    <div className="project-carousel">
                      <BeforeAfterCarousel beforeAfterImages={project.beforeAfter} />
                    </div>

                    <div className="project-body">
                      <p className="project-description">{project.description}</p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>

            {filteredProjects.length === 0 && (
              <Row>
                <Col className="text-center py-5">
                  <p className="no-results" data-aos="fade-in">
                    No se encontraron proyectos en esta categoría.
                  </p>
                </Col>
              </Row>
            )}
          </Container>
        </section>

        {/* Masonry Gallery Section */}
        <section className="mosaic-gallery-section">
          <Container>
            <MasonryGallery
              images={completedProjects.galleryImages}
              title={completedProjects.galleryTitle}
              subtitle={completedProjects.gallerySubtitle}
            />
          </Container>
        </section>

        {/* CTA Section */}
        <section className="projects-cta">
          <Container>
            <Row className="justify-content-center text-center">
              <Col lg={8}>
                <h2
                  className="cta-title"
                  data-aos="fade-down"
                  data-aos-delay="100"
                >
                  ¿Necesitas una solución industrial?
                </h2>
                <p
                  className="cta-description"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  Contáctanos hoy y descubre cómo podemos ayudarte con soluciones de aislamiento térmico de la más alta calidad.
                </p>
                <a
                  href={data.cta.button.url}
                  className="btn btn-secondary btn-lg cta-button"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-aos="zoom-in"
                  data-aos-delay="300"
                >
                  Solicita una Cotización
                </a>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
};

export default CompletedProjects;
